import {Card, DataStatus} from 'platform/components';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SALES_LEAGUE_EMPTY_MIN_HEIGHT} from '../../../constants/SALES_LEAGUE_EMPTY_MIN_HEIGHT';

/**
 * Nobody sold in the queried period. This is an ordinary response — a quiet week, or a
 * branch that has not started selling yet — so it replaces the cards and the table but
 * never the header: the period switcher above stays reachable.
 */
export function SalesLeagueEmptyBoard(props: RequiredTestIdProps) {
  return (
    <Card>
      <DataStatus
        isEmpty
        emptyMessage={i18n.t('page.salesLeague.empty')}
        emptySubheadline={i18n.t('page.salesLeague.emptySubheadline')}
        minHeight={SALES_LEAGUE_EMPTY_MIN_HEIGHT}
        data-testid={suffixTestId('empty', props)}
      />
    </Card>
  );
}
